
import { Link } from "react-router-dom";
import logo from "@/assets/logo.png";

export const LandingFooter = () => {
    return (
        <footer className="bg-gray-50 border-t border-gray-100 pt-16 pb-8">
            <div className="container mx-auto px-4">
                <div className="grid md:grid-cols-4 gap-8 mb-12">
                    <div className="col-span-1 md:col-span-1 space-y-4">
                        <div className="flex items-center gap-2">
                            <img src={logo} alt="RaffleKit" className="w-6 h-6" />
                            <span className="font-heading font-bold text-lg text-gray-700">RaffleKit</span>
                        </div>
                        <p className="text-sm text-gray-500 max-w-xs">
                            The simplest way to run viral giveaways and contests for your business.
                        </p>
                    </div>

                    <div>
                        <h4 className="font-bold text-gray-900 mb-4">Product</h4>
                        <ul className="space-y-2 text-sm text-gray-500">
                            <li><Link to="/features" className="hover:text-primary transition-colors">Features</Link></li>
                            <li><Link to="/how-it-works" className="hover:text-primary transition-colors">How It Works</Link></li>
                            <li><Link to="/pricing" className="hover:text-primary transition-colors">Pricing</Link></li>
                            <li><Link to="/admin/dashboard" className="hover:text-primary transition-colors">Dashboard</Link></li>
                            <li><Link to="/gleam-alternative" className="hover:text-primary transition-colors">RaffleKit vs. Gleam</Link></li>
                        </ul>
                    </div>

                    <div>
                        <h4 className="font-bold text-gray-900 mb-4">Company</h4>
                        <ul className="space-y-2 text-sm text-gray-500">
                            <li><Link to="/admin?mode=login" className="hover:text-primary transition-colors">Login</Link></li>
                            <li><a href="mailto:hello@rafflekit.app" className="hover:text-primary transition-colors">Support</a></li>
                        </ul>
                    </div>

                    <div>
                        <h4 className="font-bold text-gray-900 mb-4">Legal</h4>
                        <ul className="space-y-2 text-sm text-gray-500">
                            <li><Link to="/privacy" className="hover:text-primary transition-colors">Privacy Policy</Link></li>
                            <li><Link to="/terms" className="hover:text-primary transition-colors">Terms of Service</Link></li>
                        </ul>
                    </div>
                </div>

                <div className="border-t border-gray-200 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-gray-500">
                    <p>© {new Date().getFullYear()} RaffleKit. All rights reserved.</p>
                    <div className="flex items-center gap-4">
                        <Link to="/" className="hover:text-primary transition-colors">Powered by RaffleKit</Link>
                        <span>•</span>
                        <p>Made with ❤️ for small businesses.</p>
                    </div>
                </div>
            </div>
        </footer>
    );
};
